import { render, staticRenderFns } from "./SidebarE.vue?vue&type=template&id=5449f3a4"
import script from "./SidebarE.vue?vue&type=script&lang=js"
export * from "./SidebarE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports